import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const CSS = () => {
  return (
    <StartInterviewLayout type="css"/>
  )
}

export default CSS;